export const EDUCATIONLEVEL_LOADING = "EDUCATIONLEVEL_LOADING";
export const EDUCATIONLEVEL_RESET = "EDUCATIONLEVEL_RESET";
export const GET_EDUCATIONLEVEL = "GET_EDUCATIONLEVEL";
export const GET_EDUCATIONLEVEL_SUCCESS = "GET_EDUCATIONLEVEL_SUCCESS";
export const GET_EDUCATIONLEVEL_FAIL = "GET_EDUCATIONLEVEL_FAIL";
export const DELETE_EDUCATIONLEVEL = "DELETE_EDUCATIONLEVEL"
export const DELETE_EDUCATIONLEVEL_SUCCESS = "DELETE_EDUCATIONLEVEL_SUCCESS"
export const DELETE_EDUCATIONLEVEL_FAIL = "DELETE_EDUCATIONLEVEL_FAIL"
export const UPDATE_EDUCATIONLEVEL = "UPDATE_EDUCATIONLEVEL"
export const UPDATE_EDUCATIONLEVEL_SUCCESS = "UPDATE_EDUCATIONLEVEL_SUCCESS"
export const UPDATE_EDUCATIONLEVEL_FAIL = "UPDATE_EDUCATIONLEVEL_FAIL"
export const ADD_NEW_EDUCATIONLEVEL = "ADD_NEW_EDUCATIONLEVEL"
export const ADD_EDUCATIONLEVEL_SUCCESS = "ADD_EDUCATIONLEVEL_SUCCESS"
export const ADD_EDUCATIONLEVEL_FAIL = "ADD_EDUCATIONLEVEL_FAIL"